import type { FileValidationResult } from './types';

interface CreateFilePropertyValidatorParams<T extends keyof File> {
  property: T;
  validator: (params: {
    file: File;
    propertyValue: File[T];
  }) => FileValidationResult;
}

export function createFilePropertyValidator<T extends keyof File>({
  property,
  validator,
}: CreateFilePropertyValidatorParams<T>): (file: File) => FileValidationResult {
  return (file: File): FileValidationResult => {
    return validator({ file, propertyValue: file[property] });
  };
}
